module.exports = __webpack_public_path__ + "img/11.17979fcd.jpg";